// Post-login / post-terms landing route.
//
// Defaults to the legacy client-picker home. The command-center build
// (commandcenter.compasscare.app) sets REACT_APP_DEFAULT_HOME=/web/overview so
// login lands on the new command-center dashboard; stg2/prod leave it unset and
// keep the legacy landing. Read once at module load — CRA inlines the value at
// build time, so this is a compile-time constant per deployment.

export const LEGACY_HOME = "/select-client-homepage";

// Known-safe post-login landing routes. REACT_APP_DEFAULT_HOME is deploy config
// (only ever the legacy picker or the command-center dashboard), so we restrict
// it to a real, defined route via an allowlist rather than shape-checking. This
// closes both external-redirect risk (absolute/protocol-relative URLs) AND the
// NotFoundRedirect -> DEFAULT_HOME loop that a valid-looking but non-existent
// path (e.g. "/typo") would otherwise cause. Add new landings here explicitly.
export const KNOWN_HOMES = Object.freeze([LEGACY_HOME, "/web/overview"]);

// Return the requested home only if it is an allowlisted route; otherwise fall
// back to the legacy home.
export function sanitizeHome(raw) {
  if (typeof raw !== "string") return LEGACY_HOME;
  const value = raw.trim();
  return KNOWN_HOMES.includes(value) ? value : LEGACY_HOME;
}

// react-app#381: hostnames that are ALWAYS the command-center surface. The
// env var is deploy config a manual rebuild can accidentally omit — when that
// happened, login on the command-center domain landed users back on the
// legacy client-picker. The host check is a runtime fallback only: an
// explicit, allowlisted env value still wins.
export const COMMAND_CENTER_HOSTS = Object.freeze([
  "commandcenter.compasscare.app",
]);

// Resolve the landing route from (env value, runtime hostname). Explicit
// allowlisted env config wins; otherwise a command-center hostname lands on
// the dashboard; everything else keeps the legacy picker.
export function resolveHome(raw, hostname) {
  if (typeof raw === "string" && KNOWN_HOMES.includes(raw.trim())) {
    return raw.trim();
  }
  const host =
    typeof hostname === "string" ? hostname.trim().toLowerCase() : "";
  if (COMMAND_CENTER_HOSTS.includes(host)) return "/web/overview";
  return LEGACY_HOME;
}

export const DEFAULT_HOME = resolveHome(
  process.env.REACT_APP_DEFAULT_HOME,
  typeof window !== "undefined" && window.location
    ? window.location.hostname
    : "",
);
